export const SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND';
export const GATEWAY_CONNECTION_ERROR = 'GATEWAY_CONNECTION_ERROR';
export const QUOTA_REACHED = 'QUOTA_REACHED';
export const VIP_ONLY = 'VIP_ONLY';
export const PAYLOAD_INVALID = 'PAYLOAD_INVALID';
export const RECORD_NOT_FOUND = 'RECORD_NOT_FOUND';
export const RECORD_OWNER_ERROR = 'RECORD_OWNER_ERROR';
export const GATEWAY_VALIDATION_ERROR = 'GATEWAY_VALIDATION_ERROR';